import {BASE_API} from '../../utils/constantes'
import { getToken } from '../Common/token'
import { withCache, TTL } from '../../services/apiCache'
export async function getAseguradora(request_get){
    
    try {
        
        const url =  `${BASE_API}/api-orion/aseguradora/${request_get}`
            
        const params = {
            headers:{
                Authorization:`Bearer ${getToken()}`
            }
        }
        const response = await fetch(url,params)
       
        if(response.status === 200){
           
            const result= await response.json()
            
            return result
            
        }
        return false
        
    } catch (error) {
        throw new Error ("Hubo un problema, vuelva a intentar")
    }
}




// Función original sin caché
async function _getAseguradoras(query_string = null){
    try {
        
        const url =  query_string === null ? `${BASE_API}/api-orion/aseguradora/` : `${BASE_API}/api-orion/aseguradora/?${query_string}`
            
        const params = {
            headers:{
                Authorization:`Bearer ${getToken()}`
            }
        }
        const response = await fetch(url,params)
       
        if(response.status === 200){
           
            const result= await response.json()
          
            return result
            
        }
        return false
        
    } catch (error) {
        throw new Error ("Hubo un problema, vuelva a intentar")
    }
}

// Función exportada con caché (10 minutos de TTL)
export const getAseguradoras = withCache(_getAseguradoras, TTL.SHORT * 2, (query_string, forceRefresh) => {
    return `getAseguradoras_${query_string || ''}_${forceRefresh || ''}`;
});

export async function deleteAseguradora(id){
    try {
        
        
        const url =  `${BASE_API}/api-orion/aseguradora/${id}/`
        const params = {
            method:"DELETE",
            headers:{
                "Content-Type":"application/json",
                Authorization:`Bearer ${getToken()}`
            }
        }
        const response = await fetch(url,params)
        if(response.status !== 204){
            throw new Error (response.message)
        } 
        const result= {status:"sucess",data:"Se eliminó exitosamente"}
        return result
    } catch (error) {
        throw error
    }
}

export async function addAseguradoraOrion(request){
    try {
        const url =  `${BASE_API}/api-orion/aseguradora/`
        const params = {
            method:"POST",
            headers:{
                "Content-Type":"application/json",
                Authorization:`Bearer ${getToken()}`
            },
            body: JSON.stringify(request)
        }
        const response = await fetch(url,params)
    
        const result= await response.json()
        if(response.status === 201){
            result["status"]= "sucess"
        }else
            result["status"]= "error"

        return result  
    } catch (error) {
        throw error
    }
}

export async function editAseguradoraOrion(id,request){
    try {
        const url =  `${BASE_API}/api-orion/aseguradora/${id}/`
        const params = {
            method:"PUT",
            headers:{
                "Content-Type":"application/json",
                Authorization:`Bearer ${getToken()}`
            },
            body: JSON.stringify(request)
        }
        const response = await fetch(url,params)
    
        const result= await response.json()
        if(response.status === 200){
            result["status"]= "sucess"
        }else
            result["status"]= "error"
            
        return result  
    } catch (error) {
        throw error
    }
}